/* eslint-disable @typescript-eslint/no-explicit-any */
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { ErrorType } from '../../api/errorHandling';
import {
	type CommonState,
	commonReducers,
	initialCommonState,
} from '../_common/commonReducers';

export type SpyItem = Record<string, any>;

export interface SpyPhoto {
	Id: number;
	PeakWeightId: number;
	Name: string;
	FileBase64: string;
	ThumbnailBase64: string;
}

interface SpyState extends CommonState {
	photos: SpyPhoto[];
}

const initialState: SpyState = {
	...initialCommonState,
	photos: [],
};

const spySlice = createSlice({
	name: 'spy',
	initialState,
	reducers: {
		...commonReducers,
		getSpyPhotosStart(state, action: PayloadAction<number | string>) {
			return {
				...state,
				loading: { ...state.loading, getSpyPhotos: true },
			};
		},
		getSpyPhotosSuccess(state, action: PayloadAction<SpyPhoto[]>) {
			return {
				...state,
				photos: action.payload,
				success: { ...state.success, getSpyPhotos: true },
				loading: { ...state.loading, getSpyPhotos: null },
			};
		},
		getSpyPhotosFailure(state, action: PayloadAction<ErrorType>) {
			return {
				...state,
				success: { ...state.success, getSpyPhotos: false },
				loading: { ...state.loading, getSpyPhotos: null },
			};
		},
		getSpyPhotosFinish(state) {
			return {
				...state,
				success: { ...state.success, getSpyPhotos: null },
				loading: { ...state.loading, getSpyPhotos: null },
			};
		},
	},
});

export const {
	getTableStart,
	getTableSuccess,
	getTableFailure,
	getTableFinish,

	getItemStart,
	getItemSuccess,
	getItemFailure,
	getItemFinish,

	createItemStart,
	createItemSuccess,
	createItemFailure,
	createItemFinish,

	updateItemStart,
	updateItemSuccess,
	updateItemFailure,
	updateItemFinish,

	deleteItemsStart,
	deleteItemsSuccess,
	deleteItemsFailure,
	deleteItemsFinish,

	deleteItemStart,
	deleteItemSuccess,
	deleteItemFailure,
	deleteItemFinish,

	getTableStructureStart,
	getTableStructureSuccess,
	getTableStructureFailure,

	getItemDocumentsStart,
	getItemDocumentsSuccess,
	getItemDocumentsFailure,
	getItemDocumentsFinish,

	uploadItemDocumentsStart,
	uploadItemDocumentsSuccess,
	uploadItemDocumentsFailure,
	uploadItemDocumentsFinish,

	deleteItemDocumentStart,
	deleteItemDocumentSuccess,
	deleteItemDocumentFailure,
	deleteItemDocumentFinish,

	getTableExcelStart,
	getTableExcelSuccess,
	getTableExcelFailure,
	getTableExcelFinish,

	getSpyPhotosStart,
	getSpyPhotosSuccess,
	getSpyPhotosFailure,
	getSpyPhotosFinish,
} = spySlice.actions;

export default spySlice;
